export interface HrDashboardScopeParams {
  storeId?: number
  storeIds?: number[]
}

/**
 * Query keys must describe a scope semantically, not depend on the order in which stores were
 * selected. Keep an explicit empty array distinct from an omitted scope: callers may use a
 * sentinel-backed empty selection and must never silently fall back to the whole network.
 */
export const normalizeHrDashboardParams = <T extends HrDashboardScopeParams>(params: T): T => {
  if (params.storeIds === undefined) return { ...params }

  return {
    ...params,
    storeIds: [...new Set(params.storeIds)].sort((left, right) => left - right),
  }
}
